// ================================================================================
// dropdown-menu.js
// ドロップダウンメニュー用のスクリプトファイル
// ================================================================================

export default function dropDownMenu() {

	const dropDownTarget = document.querySelectorAll('.site-menu-item.has-children');
	const menuOpenTarget = document.querySelector('body');

	for ( let i = 0; i < dropDownTarget.length; i++ ) {
		dropDownTarget[i].addEventListener('mouseover', () => {
			menuOpenTarget.classList.add('is-dropdown-open');
		});
		dropDownTarget[i].addEventListener('mouseleave', () => {
			menuOpenTarget.classList.remove('is-dropdown-open');
		});
	}

}
